export interface Incoterm {
    id?: number;
    name?: string;
    description?: string;
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
}

export interface IncotermDataForm {
    id?: number;
    name: string;
    description?: string;
    is_active?: boolean;
}

export const defaultIncotermDataForm: IncotermDataForm = {
    name: '',
    description: '',
    is_active: true
};

export interface IncotermFilters {
    id?: number | null;
    name?: string | '';
    is_active?: boolean | '';
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
